(function () {
  'use strict';

  angular.module('app').component('billsPage', BillsPageComponent());

  function BillsPageComponent() {
    return {
      bindings: {},
      controller: BillListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bills/bills-page.component.html',
    };
  }

  BillListCtrl.$inject = ['$location', 'UtilService', 'AbilityService', 'BillService'];

  function BillListCtrl($location, UtilService, AbilityService, BillService) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = BillService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

    // vm.filterCriteria.by_status = 'unpaid'; // TODO: due ??

    vm.permissions = {
      canCreate: AbilityService.can('create_bill_accountadmin'),
    };

    // Methods
    vm.createBill = createBill;
    vm.onShowBill = onShowBill;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      BillService.getBills(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalAmounts = vm.items.totalAmounts;

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    }

    function createBill() {
      $location.path('/bills/new');
    }

    function onShowBill(item, mode) {
      $location.path(`/bills/${item.id}`).search({ mode: mode });
    }
  }
})();
